import { render, staticRenderFns } from "./UndoMessage.vue?vue&type=template&id=f2e1483c&"
import script from "./UndoMessage.vue?vue&type=script&lang=ts&"
export * from "./UndoMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports